import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function FailedSolutions() {
  return <section className="py-12 px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-134">
      <div className="max-w-[680px] mx-auto" data-id="element-135">
        <h2 className="text-2xl md:text-3xl font-serif text-[var(--text-heading)] mb-8 text-center" data-id="element-136">
          Déjame preguntarte algo directo
        </h2>

        <div className="space-y-5 text-lg text-[var(--text-primary)] leading-relaxed" data-id="element-137">
          <p data-id="element-138">
            ¿Cuánto tiempo más vas a aguantar este peso sin entender para qué
            sirve?
          </p>
          <p data-id="element-139">
            ¿Cuántas mañanas más vas a despertar con esa sensación de vacío en
            el estómago, mirando tu situación y sin ver salida?
          </p>
          <p data-id="element-140">
            ¿Cuántos domingos más vas a sentarte en una iglesia, escuchar un
            mensaje de "victoria" y regresar a casa sintiéndote más solo que
            antes?
          </p>

          <div className="bg-[var(--bg-elevated)] rounded-lg p-6 border border-[var(--accent)]/20 mt-6" data-id="element-141">
            <p className="text-[var(--text-heading)] font-serif text-xl mb-4 text-center" data-id="element-142">
              El problema no es tu fe.
            </p>
            <p className="text-[var(--text-primary)] text-center" data-id="element-143">
              <strong className="text-[var(--accent)]" data-id="element-144">
                El problema es que nadie te ha dado un mapa para navegar el
                dolor.
              </strong>
            </p>
          </div>

          <div className="grid gap-3 mt-6" data-id="element-145">
            {['Te dijeron que "confíes", pero no qué hacer cuando la confianza se siente vacía.', 'Te dijeron que "ores más", pero no cómo orar cuando las palabras no salen.', 'Te dijeron que "Dios tiene un plan", pero nadie te mostró cómo reconocerlo en el caos.'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 p-4 bg-[var(--bg-elevated)] rounded border border-transparent" data-id="element-146">
                <X className="w-5 h-5 text-[var(--red-emphasis)] flex-shrink-0 mt-1" data-id="element-147" />
                <p className="text-[var(--text-muted)]" data-id="element-148">{item}</p>
              </motion.div>)}
          </div>

          <div className="mt-8 p-5 border-l-2 border-[var(--red-emphasis)] bg-[var(--red-emphasis)]/5" data-id="element-149">
            <p className="text-[var(--text-heading)] font-serif italic text-xl mb-3" data-id="element-150">
              Eso no es falta de fe. Eso es falta de información.
            </p>
            <p className="text-[var(--text-primary)]" data-id="element-151">
              Y así llevas días, semanas, meses... dando vueltas en el mismo
              desierto, sin brújula, sin agua y sin entender por qué Dios que
              dice amarte, permite que sigas sufriendo.
            </p>
            <p className="text-[var(--accent)] font-bold mt-3 uppercase tracking-wide text-sm" data-id="element-152">
              Y eso termina hoy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}